import ComingSoon from '../ComingSoon';

const StockLocations = () => {
  return <ComingSoon />;
};

export default StockLocations;
